import {LinePlotDisplayRowFnType} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';
import {getGroupAggDisplayRow} from './groupAggDisplayValues';
import {getGroupSettingDisplayRow} from './groupingDisplayValues';
import {getMaxRunsDisplayRow} from './maxRunsDisplayValues';
import {
  getSmoothingTypeDisplayRow,
  getSmoothingWeightDisplayRow,
} from './smoothingDisplayValues';
import {getXAxisDisplayRow} from './xAxisDisplayValues';
import {getXAxisFormatDisplayRow} from './xAxisFormatDisplayValues';
import {getXAxisMaxDisplayRow} from './xAxisMaxDisplayValues';
import {getXAxisMinDisplayRow} from './xAxisMinDisplayValues';
import {getXLogScaleDisplayRow} from './xLogScaleDisplayValues';
import {getYAxisMaxDisplayRow} from './yAxisMaxDisplayValues';
import {getYAxisMinDisplayRow} from './yAxisMinDisplayValues';
import {getYLogScaleDisplayRow} from './yLogScaleDisplayValues';
export const LINE_PLOT_TEMPLATE_DISPLAY_FNS: Record<
  keyof LinePlotTemplateSettings,
  LinePlotDisplayRowFnType
> = {
  groupAgg: getGroupAggDisplayRow,
  maxRuns: getMaxRunsDisplayRow,
  smoothingType: getSmoothingTypeDisplayRow,
  smoothingWeight: getSmoothingWeightDisplayRow,
  useRunsTableGroupingInPanels: getGroupSettingDisplayRow,
  xAxis: getXAxisDisplayRow,
  xLogScale: getXLogScaleDisplayRow,
  xAxisMin: getXAxisMinDisplayRow,
  xAxisMax: getXAxisMaxDisplayRow,
  xAxisFormat: getXAxisFormatDisplayRow,
  yLogScale: getYLogScaleDisplayRow,
  yAxisMin: getYAxisMinDisplayRow,
  yAxisMax: getYAxisMaxDisplayRow,
};
